<template>
  <div>
    <div ref="backDiv" id="back-div" v-show="isActive" class="back-div"></div>
    <div
      id="drawer"
      class="drawer"
      :class="{ active: isActive }"
      :style="getStyle()"
    >
      <a class="hamburger clearfix" @click.prevent="$emit('closed')">
        <span class="material-icons md-36">menu</span>
      </a>
      <ul class="nav flex-column clearfix" v-if="user">
        <li class="nav-item">
          <router-link class="nav-link active" to="/profile">
            {{ $t("message.myAccount") }}
          </router-link>
        </li>
        <li class="nav-item" v-if="showLoyaltyOption">
          <router-link
            class="nav-link"
            :to="{
              name: useStampCollection ? 'userStamps' : 'loyalty',
              params: {
                storeid: currentStoreDoc.ID,
                storename: currentStoreDoc.Name,
              },
            }"
            >{{ $t("message.loyalty") }}</router-link
          >
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :to="{
              name: 'orderhistory',
              params: {
                storeid: currentStoreDoc.ID,
                storename: currentStoreDoc.Name,
              },
            }"
            >{{ $t("message.orderHistory") }}</router-link
          >
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :to="{
              name: 'ordertracking',
              params: {
                storeid: currentStoreDoc.ID,
                storename: currentStoreDoc.Name,
              },
            }"
            >{{ $t("message.orderTracking") }}</router-link
          >
        </li>
        <li class="nav-item">
          <a class="nav-link theme-link" href="#" @click="goToMainPage">
            {{ capitalizeFirstLetter($t("message.stores")) }}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#" @click="signOut">
            {{ $t("message.logOut") }}
          </a>
        </li>
      </ul>
      <ul class="nav flex-column clearfix" v-else-if="viewConfig.LogIn">
        <li class="nav-item">
          <a class="nav-link active" @click="openLogin(true)">
            {{ $t("message.login") }}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link active" @click="openLogin(false)">
            {{ $t("message.register") }}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link theme-link" href="#" @click="goToMainPage">
            {{ capitalizeFirstLetter($t("message.stores")) }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import {capitalizeFirstLetter} from '../../filters/capitalizeFirstLetter';

export default {
  name: "Drawer",

  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters([
      "user",
      "cartValue",
      "viewConfig",
      "mobileStyles",
      "currentStoreDoc",
      "useStampCollection",
      "getFirstValidRedemptionRule",
      "applicableLoyalityRule",
      "getMenuEntity",
    ]),
    showLoyaltyOption() {
      return this.applicableLoyalityRule.length > 0 &&
        (this.getFirstValidRedemptionRule !== null ||
        this.getMenuEntity.PointsToDollarRatio > 0);
    },
  },

  mounted() {
    var that = this;
    this.$refs.backDiv.onclick = function() {
      if (that.isActive) {
        that.$emit("closed");
      }
    };
  },
  methods: {
    ...mapActions(["logout"]),
    ...mapMutations(["setShowOverlay"]),
    capitalizeFirstLetter,
    signOut() {
      this.logout();
      this.navigateShoppingcart();
    },
    navigateShoppingcart() {
      if (window.location.pathname.indexOf("giftcards") != -1)
        this.$router.push("/store/" + this.currentStoreDoc.Name + "/giftcards");
      else this.$router.push("/store/" + this.currentStoreDoc.Name);
    },
    getStyle() {
      var styles = [];
      styles.push(this.mobileStyles.primaryColourImportant);
      styles.push(this.mobileStyles.nav);
      return styles;
    },
    goToMainPage() {
      if(this.$route.name === 'mainpage') {
        this.$emit('closed');
      } else {
        this.$router.push({name: 'mainpage'});
      }
    },
    openLogin(login) {
      this.$emit("closed");
      
      this.setShowOverlay({value: true, login: login});
    },
  },
};
</script>
